import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="resend"
export default class extends Controller {
	static values = {
		resendableIn: { type: Number, default: 60 },
		resendableRate: { type: Number, default: 60 }
	}

	static targets = [ "progress" ]

	resendableInValueChanged(resendableIn) {
		this.progressTarget.textContent = Math.ceil(resendableIn)
		this.progress = (resendableIn / this.resendableRateValue) * 100
		this.element.disabled = resendableIn > 0

		if (resendableIn <= 0) {
			this.progressTarget.remove()
		} else {
			setTimeout(() => {
				this.resendableInValue = Math.max(resendableIn - 1, 0)
			}, 1000)
		}
	}

	set progress(value) {
		this.progressTarget.style.setProperty("--value", value)
		this.progressTarget.setAttribute("aria-valuenow", value)
	}
}
